import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { MoreHorizontal } from "lucide-react";

import { PermissionGuard } from "~/components/permission-guard";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/cloudflare-redirects")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <PermissionGuard permission="redirects:manage">
      <div className="w-full max-w-4xl space-y-6 p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-2">
            <h1 className="text-2xl font-semibold">Cloudflare Redirects</h1>
            <p className="text-sm text-muted-foreground">
              Manage the Cloudflare redirect list for captions.ai.
            </p>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="icon" className="size-8">
                <MoreHorizontal className="size-4" aria-hidden="true" />
                <span className="sr-only">Redirects menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onSelect={() => navigate({ to: "/cloudflare-redirects" })}>
                Manage Redirects
              </DropdownMenuItem>
              <DropdownMenuItem onSelect={() => navigate({ to: "/cloudflare-redirects/remove" })}>
                Remove Redirects
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <Outlet />
      </div>
    </PermissionGuard>
  );
}
